<template>
  <div class="salesmanzhucehuiyuanPage">
    <XR-head titleText="注册创客" :rightShow="false" ref="headObj"></XR-head>
    <div class="text">
    </div>
    <div>      
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="会员名" type="text" helpText="会员名为自动生成，无需手填，如已存在，请刷新页面即可" labelFloat fullWidth disabled="disabled" v-model="username" />
        </mu-col>
      </mu-row>      
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="100" class="rowFiled">          
            <mu-auto-complete hintText="必须是您管理的会员" labelFloat label="推荐人" fullWidth v-model="editInfo.tjrusername" />   
        </mu-col>
      </mu-row>  
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="openDialog"  />
        </mu-col>
      </mu-row>
    </div>    
    
    <mu-dialog :open="dialog" title="请输入支付密码" @close="closeDialog">
      <p>注册众创会员需要使用金币支付费用</p>
      <mu-text-field hintText="支付密码" type="password" v-model="editInfo.payPassword" v-if="safeInfo.IsMpass" />
      <router-link :to="'/usercenter/payPassword?redirect_url='+localUrl" v-if="!safeInfo.IsMpass">尚未设置支付密码，点击设置</router-link>
      <mu-flat-button slot="actions" @click="closeDialog" primary label="取消"/>
      <mu-flat-button slot="actions" primary @click="registerMember" label="确定"/>
    </mu-dialog>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>
<script>
import md5 from 'js-md5'
export default {
  data () {
    return {
      username:'',
      editInfo:{
        tjrusername:'',
        payPassword:'',
        userNameList:[]
      },
      dialog : false,
      safeInfo:{
        IsMpass:false
      },
      localUrl: encodeURIComponent(window.location.href)
    }
  },
  mounted(){
    // this.$refs.XRtoast.load('加载中...')
    this.getNextMemberName()
    this.getUserSafe()
  },
  methods: {
    openDialog () {
      if(!this.username){
          this.$refs.XRtoast.failed("请输入会员名", true)
          return
      }
      if(!this.editInfo.tjrusername){
          this.$refs.XRtoast.failed("请输入推荐人会员名", true)
          return
      }

      this.dialog = true
    },
    closeDialog () {
      this.dialog = false
    },  
    getUserSafe(){      
      var ths = this
      ths.$post(
        "/Salesman/UserServer/GetUserSafeInfo"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.safeInfo = res.Data
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    getNextMemberName(){      
      var ths = this
      ths.$post(
        "/Salesman/UserServer/GetMemberNextUserName"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.username = res.Data
          ths.loaded =false
          ths.$refs.XRtoast.hide()
        }
      });
    },
    registerMember(){    
      this.closeDialog()       
      var ths = this

      if(!this.editInfo.payPassword){
          ths.$refs.XRtoast.failed("请输入支付密码", true)
          return
      }
      ths.editInfo.payPassword = md5(ths.editInfo.payPassword)

      var userNameList = this.username.split(',')
      ths.editInfo.userNameList = userNameList

      ths.$post(
        "/Salesman/SalesmanServer/RegisterMember", this.editInfo
      ).then(function(res) {
        ths.editInfo.payPassword =''
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true) 
        }else{  
          // ths.getNextMemberName()
          // ths.editInfo.tjrusername =''
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.$router.push('/salesman/mymemberviplist')
          })
        }
      });
    }
  }
}
</script>
<style>
      body .salesmanzhucehuiyuanPage{
        background: #fff;
      }
      .salesmanzhucehuiyuanPage .text{
        width: 95%;
        text-align: right;
        margin-top: 5%;
      }
      .salesmanzhucehuiyuanPage .fa-search{
        color: #f2b19f;
      }
      .salesmanzhucehuiyuanPage{
        background: white;
      }
      .salesmanzhucehuiyuanPage .rowFiled{
        padding: 0 5%;
      }
      .salesmanzhucehuiyuanPage .forgetBtn {
        float: right;
      }

      .salesmanzhucehuiyuanPage .btn-div {
        padding: 40px 5% 30px;
      }
      .salesmanzhucehuiyuanPage .submit {
        height: 50px;
      }
</style>



// WEBPACK FOOTER //
// src/pages/salesman/registerMember.vue